import * as React from 'react'
import * as styles from '../style/index.scss'
import {FormattedMessage} from 'react-intl'

interface TabBarProps {
    current: string
    changeTabBar: (e) => void
}

class TabBar extends React.Component<TabBarProps, any> {
    constructor(props) {
        super(props)
    }

    changeTabBar = value => {
        this.props.changeTabBar(value)
    }

    render() {
        return (
            <section className={styles.tabBarWrap}>
                <div className={`${styles.tabItem} ${this.props.current === '0' && styles.tabItemActive}`} onClick={() => this.changeTabBar('0')}>
                    <FormattedMessage id="myDataPlan.tabbar.available"/>
                    {this.props.current === '0' && <span className={styles.underLine}/>}
                </div>
                <div className={`${styles.tabItem} ${this.props.current === '1' && styles.tabItemActive}`} onClick={() => this.changeTabBar('1')}>
                    <FormattedMessage id="myDataPlan.tabbar.expired"/>
                    {this.props.current === '1' && <span className={styles.underLine}/>}
                </div>
            </section>
        )
    }
}

export default TabBar
